import React, { useState } from 'react';
import './SubscriptionPopup.css';
import QRComponent from '../ImageComponent/QRComponent';
import { useSelector, useDispatch } from 'react-redux';
import { setSubcriptionPopUp, setLoginPopupOpen } from '../../reducers/appReducer';

interface SubscriptionPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const SubscriptionPopup: React.FC<SubscriptionPopupProps> = ({ isOpen, onClose }) => {
  const [showQR, setShowQR] = useState<{ [key: string]: boolean }>({
    weekly: false,
    monthly: false,
    annual: false
  });

  const toggleQR = (plan: string) => {
    setShowQR(prev => ({
      ...prev,
      [plan]: !prev[plan]
    }));
  };

  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user.user);
  const isLoggedIn = useSelector((state: any) => state.user.isLoggin);

  const onSubscriptionClick = (plan: string) => {
    if (isLoggedIn && user && (user.email || user.displayName)) {
      toggleQR(plan);
    } else {
      dispatch(setSubcriptionPopUp(false));
      dispatch(setLoginPopupOpen(true));
    }
  }

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="popup-content">
          <h1 className="popup-title">Subscribe to get more credits</h1>
          
          <div className="subscription-options">
            <div className="subscription-card">
              <div className="iphone-only-tag">iPhone only</div>
              <h2 className="subscription-type">Weekly</h2>
              <div className="price">200.000 VND</div>
              <div className="credits">
                <span className="coin-icon">⚪</span> 600<span className="credit-period">credits/week</span>
              </div>
              <div className={`qr-container ${showQR.weekly ? 'show-qr' : 'hide-qr'}`}>
                <QRComponent amount={200000} />
              </div>
              <div className={`features ${showQR.weekly ? 'hide-features' : ''}`}>
                <div className="feature-item">
                  <span className="feature-text">Fast Processing</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Watermark-free</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">HD to 3K+ photos</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Access to Website</span>
                  <span className="check-icon">✓</span>
                </div>
              </div>
              
              <button 
                className="subscription-button iphone-button"
                onClick={() => onSubscriptionClick('weekly')}
              >
                {showQR.weekly ? 'Back' : isLoggedIn && user && (user.email || user.displayName) ? 'iPhone app' : 'Login'}
              </button>
              <div className="subscription-note">Access to both app and website</div>
            </div>
            
            <div className="subscription-card">
              <h2 className="subscription-type">Monthly</h2>
              <div className="price">500.000 VND</div>
              <div className="credits">
                <span className="coin-icon">⚪</span> 1,000<span className="credit-period">credits/month</span>
              </div>
              <div className={`qr-container ${showQR.monthly ? 'show-qr' : 'hide-qr'}`}>
                <QRComponent amount={500000} />
              </div>
              <div className={`features ${showQR.monthly ? 'hide-features' : ''}`}>
                <div className="feature-item">
                  <span className="feature-text">Fast Processing</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Watermark-free</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">HD to 3K+ photos</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Access to iPhone app</span>
                  <span className="check-icon">✓</span>
                </div>
              </div>
              
              <button 
                className="subscription-button"
                onClick={() => onSubscriptionClick('monthly')}
              >
                {showQR.monthly ? 'Back' : isLoggedIn && user && (user.email || user.displayName) ? 'Subscribe' : 'Login'}
              </button>
              <div className="subscription-note">Auto renew, cancel anytime</div>
            </div>
            
            <div className="subscription-card">
              <div className="discount-tag">25% OFF</div>
              <h2 className="subscription-type">Annual</h2>
              <div className="price">750.000 VND <span className="original-price">1.000.000 VND</span></div>
              <div className="credits">
                <span className="coin-icon">⚪</span> 8,000<span className="credit-period">credits/year</span>
              </div>
              <div className={`qr-container ${showQR.annual ? 'show-qr' : 'hide-qr'}`}>
                <QRComponent amount={750000} />
              </div>
              <div className={`features ${showQR.annual ? 'hide-features' : ''}`}>
                <div className="feature-item">
                  <span className="feature-text">Fast Processing</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Watermark-free</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">HD to 3K+ photos</span>
                  <span className="check-icon">✓</span>
                </div>
                <div className="feature-item">
                  <span className="feature-text">Access to iPhone app</span>
                  <span className="check-icon">✓</span>
                </div>
              </div>
              
              <button 
                className="subscription-button"
                onClick={() => onSubscriptionClick('annual')}
              >
                {showQR.annual ? 'Back' : isLoggedIn && user && (user.email || user.displayName) ? 'Subscribe' : 'Login'}
              </button>
              <div className="subscription-note">Auto renew, cancel anytime</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPopup;
